var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlGreenSeven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4517_403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.125 13.4992H9V16.4992C9 17.3272 9.6705 17.9992 10.5 17.9992C11.3295 17.9992 12 17.3272 12 16.4992V7.42422H12.375C15.2025 7.42422 18 5.37972 18 1.19922C18 0.578219 17.496 0.0742188 16.875 0.0742188H14.625C11.5245 0.0742188 9 2.59722 9 5.69922V7.30272C7.6965 5.60922 5.6715 4.49922 3.375 4.49922H1.125C0.504 4.49922 0 5.00322 0 5.62422V6.37422C0 10.3027 3.1965 13.4992 7.125 13.4992Z",
    fill: "#92B893"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2039 9.13585C16.9879 9.07735 15.4309 9.88284 14.9989 10.0208V11.7158C16.9084 12.0848 18.3259 12.5813 19.9039 13.2758L18.7939 17.9558C18.5239 19.0658 18.7339 20.2508 19.3639 21.2108C19.9939 22.1708 21.0139 22.8158 22.1389 22.9958L32.4139 24.6608C33.0139 26.3858 33.2239 28.2758 32.8489 30.3608H32.8339C32.3254 28.4333 30.5839 27.0008 28.4989 27.0008C26.5519 27.0008 24.9049 28.2518 24.2794 29.9858H13.2184C12.5929 28.2518 10.9459 27.0008 8.9989 27.0008C6.9844 27.0008 5.2954 28.3388 4.7239 30.1673C4.5094 30.0623 4.2844 29.9213 4.0639 29.6708C3.3439 28.8608 2.3389 26.5958 3.5989 20.5208C3.9439 18.8708 4.3789 17.4458 4.9339 16.2458C3.9289 16.0358 2.9839 15.6608 2.1289 15.1658C1.5289 16.5458 1.0339 18.1208 0.658903 19.9058C-0.511097 25.5908 -0.106097 29.5808 1.8889 31.7408C2.9119 32.8568 4.0849 33.2228 4.8964 33.3308C5.5999 34.9013 7.1704 36.0008 8.9989 36.0008C10.9579 36.0008 12.6094 34.7363 13.2274 32.9858H24.2704C24.8884 34.7363 26.5399 36.0008 28.4989 36.0008C30.3154 36.0008 31.8754 34.9133 32.5849 33.3608H32.8489C34.2739 33.3608 35.4889 32.3258 35.7589 30.9158C38.2639 17.2208 21.4789 10.1558 17.2039 9.13585Z",
    fill: "#92B893"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4517_403"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlGreenSeven);
export default __webpack_public_path__ + "static/media/al-green-seven.8e915de3d88882193cd726c2a578ad59.svg";
export { ForwardRef as ReactComponent };